export const NOT_ASSIGNED_TO_USER_ID = 'not-assigned-to-user';
export const emptyUserForOfficeDeletionListItem = {
  id: NOT_ASSIGNED_TO_USER_ID,
  img: null,
  name: 'Alle gebruikers',
};
